<template>
  <div id='content'>
    <div >
      <!-- <b-row>
        <b-col sm='8'>
          <h3>Web Links</h3>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col sm='12'>
          <div v-for="weblink in arrayWebLinks" :key="weblink.mswl_ID" class="mt-20"> 
              <a :href="weblink.mswl_hlink">{{weblink.mswl_hlink}}</a>
              <div class="ml-15 mt-15">{{ stripHtml(weblink.mswl_desc) }}</div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Footer de botones -->
    <div id='footer'>
      <!-- Esc salir -->
      <!-- <img class='btn-footer-izq' src='@/assets/images/Btn-ESC.gif'>
      <label class='txt-footer-izq'>{{ $t('lang.comun.salir') }}</label> -->
    </div>
    <!-- FIN. Footer de botones -->
  </div>
</template>
<script>
import { WeblinkApiService } from '@/api/WeblinkApiService'

const webLinkApiService = new WeblinkApiService()

export default {
  data () {
    return {
      arrayWebLinks: [],
      opuid: this.$store.getters.getOpuid,
      user: this.$store.getters.getUserName,
      wsid: this.$store.getters.getWsid
    }
  },
  created() {
    this.cambioTitulo()
    this.init();
  },
  computed: {
    cambiotienda () {
      return [this.$store.getters.getWsid,this.$store.getters.getOpuid] ;
    }
  },
  watch: {
    cambiotienda (value) {
      this.wsid = value[0];
      this.opuid = value[1];
      this.init();
    }
  },
  methods: {
    init() {
      this.arrayWebLinks.length = 0
      this.getAllWebLink()
    },
    cambioTitulo () {
      this.$store.state.tituloIcono = `<i class="icon-earth"></i>`
      this.$store.state.titulo = "Web links"
    },
    stripHtml (html)  {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },  
    getAllWebLink() {     
      webLinkApiService.getAllWebLink(this.opuid)
        .then(data => {
          console.log('Weblink - getAllWebLinks', data.length, 'OK')
          this.arrayWebLinks = data
        })
        .catch(error => {
          console.log('Weblink - getAllWebLinks', error, 'ERROR')
        })
    }
  },
 
}
</script>
